import styled from '@emotion/styled';
import { Select } from '@material-ui/core';

export const CustomPaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
`;

export const CustomPaginationActionsContainer = styled.div`
  display: flex;
  padding: 0 8px;
  align-items: center;

  .MuiPaginationItem-textSecondary.Mui-selected {
    background-color: #eff3f6;
    color: #10a4e4;

    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;

export const CustomPaginationSelect = styled(Select)`
  .MuiSelect-root {
    padding: 0px 24px 0px 8px !important;
    color: #333;
  }
  .MuiSelect-icon {
    right: 0 !important;
    color: #333;
  }
  height: 23px !important;
  border-radius: 0 !important;
  margin: 0 8px;
`;
